import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import ApplicationModal from './ApplicationModal';

const FinalCTA = () => {
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);

  const handleApplyClick = () => {
    setIsApplicationModalOpen(true);
  };

  return (
    <>
      <section id="final-cta" className="py-20 relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="/DSC04169.jpg"
            alt="Beautiful farm landscape with rolling hills"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-slide-up">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 uppercase">
              Start Building the Life You Want – Through a Career in Land Sales
            </h2>
            <p className="text-xl text-gray-200 max-w-4xl mx-auto">
              Don't let this opportunity pass you by. Apply now to join our fast-growing team of professional land specialists at KILOTERRA, for the opportunity at financial freedom and independence.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {/* Benefits Section */}
            <div className="animate-slide-in-left mb-12">
              <h3 className="text-2xl font-bold text-white mb-8 uppercase text-center">
                What You'll Get as a KILOTERRA Agent:
              </h3>
              <div className="space-y-4">
                {[
                  'Freedom to make your own schedule and live life on your terms',
                  'The opportunity to utilize your experience and knowledge of land to build a life-changing career',
                  'The training, tools, and resources necessary to earn a multiple-six figure income and truly experience financial independence',
                  'Access to a team of high performing agents to learn from and be inspired by',
                  'The ability to make a meaningful impact on other people\'s lives',
                  'The opportunity to reach professional and personal goals you may have never thought possible'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <div className="flex-shrink-0 w-2 h-2 bg-kiloterra-yellow mt-3"></div>
                    <p className="text-gray-200">{benefit}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Apply Now Button */}
            <div className="text-center">
              <button
                onClick={handleApplyClick}
                className="bg-kiloterra-yellow text-kiloterra-dark py-4 px-12 font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 inline-flex items-center justify-center space-x-2 uppercase tracking-wide"
              >
                <span>Apply Now</span>
                <ArrowRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <ApplicationModal 
        isOpen={isApplicationModalOpen} 
        onClose={() => setIsApplicationModalOpen(false)}
        source="final_cta"
      />
    </>
  );
};

export default FinalCTA;